import React from 'react';
import Sym from '../components/Sym';

/**
 * Showcase «Portal 24/7» (banda oscura): copy + mockup flotante del portal del
 * colaborador con sus últimos recibos. El nombre del mockup es genérico de demo
 * (muestra de UI, no un testimonio) para respetar la decisión §4.7.
 */
const POINTS = [
  'Recibos timbrados disponibles al instante',
  'Histórico completo, ordenado por periodo',
  'Descarga el PDF y el XML cuando lo necesiten',
];
const RECIBOS = [
  { q: 'Quincena 14', d: 'Jul 2026' },
  { q: 'Quincena 13', d: 'Jul 2026' },
  { q: 'Quincena 12', d: 'Jun 2026' },
];

const PortalShowcase2 = () => (
  <section style={{ maxWidth: 1200, margin: '0 auto', padding: '0 clamp(20px,5vw,40px) clamp(48px,7vw,96px)' }}>
    <div data-dark className="reveal" style={{ position: 'relative', overflow: 'clip', display: 'flex', flexWrap: 'wrap', gap: 'clamp(32px,5vw,64px)', alignItems: 'center', background: 'linear-gradient(135deg,#0E1A32,#0A1324)', borderRadius: 28, padding: 'clamp(28px,4vw,56px)', border: '1px solid rgba(255,255,255,.07)' }}>
      <div style={{ position: 'absolute', bottom: -120, right: -40, width: 320, height: 320, borderRadius: '50%', background: 'radial-gradient(circle,rgba(47,107,255,.2),transparent 65%)', filter: 'blur(10px)' }} />
      {/* Texto */}
      <div style={{ position: 'relative', flex: '1 1 360px', minWidth: 280 }}>
        <span style={{ font: "700 .8rem 'IBM Plex Mono'", letterSpacing: '.14em', textTransform: 'uppercase', color: '#6FA0FF' }}>Portal 24/7</span>
        <h2 style={{ font: "600 clamp(1.9rem,4vw,2.9rem)/1.06 'Source Serif 4'", letterSpacing: '-.02em', color: '#F4F7FC', margin: '12px 0 16px', textWrap: 'balance' }}>
          El portal que a tus colaboradores <span style={{ fontStyle: 'italic', color: '#6FA0FF' }}>les va a encantar</span>
        </h2>
        <p style={{ font: "400 1.1rem/1.6 'Hanken Grotesk'", color: '#9DA9C0', margin: '0 0 22px' }}>
          Se acabaron los correos pidiendo recibos. Cada persona entra desde su celular y consulta, descarga y comparte sus comprobantes cuando quiera.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 13 }}>
          {POINTS.map((p) => (
            <div key={p} style={{ display: 'flex', gap: 11, alignItems: 'flex-start' }}>
              <Sym name="check_circle" size={22} color="#6FA0FF" />
              <span style={{ font: "500 1.02rem/1.4 'Hanken Grotesk'", color: '#C7D0E0' }}>{p}</span>
            </div>
          ))}
        </div>
      </div>
      {/* Mockup del teléfono */}
      <div style={{ position: 'relative', flex: '1 1 300px', minWidth: 250, display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: 230, background: '#060B18', border: '1px solid rgba(255,255,255,.08)', borderRadius: 32, padding: 12, boxShadow: '0 30px 60px -22px rgba(0,0,0,.8)', animation: 'ls2-floatY 7s ease-in-out infinite' }}>
          <div style={{ background: '#F4F6FB', borderRadius: 22, overflow: 'hidden' }}>
            <div style={{ background: '#2F6BFF', padding: '18px 16px 16px', color: '#fff' }}>
              <div style={{ font: "500 .72rem 'Hanken Grotesk'", opacity: 0.85 }}>Hola de nuevo,</div>
              <div style={{ font: "700 1.1rem 'Hanken Grotesk'" }}>Ana López</div>
            </div>
            <div style={{ padding: 14 }}>
              <div style={{ font: "700 .68rem 'IBM Plex Mono'", letterSpacing: '.08em', textTransform: 'uppercase', color: '#9AA4B8', marginBottom: 10 }}>Últimos recibos</div>
              {RECIBOS.map((r, i) => (
                <div key={r.q} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#fff', borderRadius: 12, padding: '11px 12px', marginBottom: i < RECIBOS.length - 1 ? 9 : 0, boxShadow: '0 1px 2px rgba(14,26,48,.08)' }}>
                  <div>
                    <div style={{ font: "700 .78rem 'Hanken Grotesk'", color: '#0E1A30' }}>{r.q}</div>
                    <div style={{ font: "500 .68rem 'Hanken Grotesk'", color: '#9AA4B8' }}>{r.d}</div>
                  </div>
                  <Sym name="download" size={20} color="#2F6BFF" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default PortalShowcase2;
